import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import MainStyle from "../components/Style.module.css"
import InstagramWarning from "../components/InstagramWarning";

export default function PriceList() {
    return <div className={MainStyle.startPageMainWithBackground}>
        <InstagramWarning/>
        <div className={StaticPageStyles.pricePpage}>

            <div className={StaticPageStyles.priceContainer}>
                <br/>
                <h3>Актуальні ціни на проведення ігор на платформі LeelaOnline</h3>
                <h4 style={{textAlign:"left", marginLeft: "24px", paddingLeft: "0.5em", marginBottom: "-12px", backgroundColor: "white", zIndex:50, width:"10.5em"}}> Ігри з відео звязком</h4>
                <table className={StaticPageStyles.priceTable}>
                    <thead>
                    <th>Тип гри</th>
                    <th>Ціна</th>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Проведення індивідуальної гри</td>
                        <td className={StaticPageStyles.priceCell}>3
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td>Проведення особистої гри (для себе)</td>
                        <td className={StaticPageStyles.priceCell}>0.5
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Проведення групової гри</b></td>
                    </tr>
                    <tr>
                        <td> - гра з 2 гравцями</td>
                        <td className={StaticPageStyles.priceCell}>5
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - гра з 3 гравцями</td>
                        <td className={StaticPageStyles.priceCell}>7
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - гра з 4 гравцями</td>
                        <td className={StaticPageStyles.priceCell}>9
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - гра з 5 гравцями</td>
                        <td className={StaticPageStyles.priceCell}>10
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - гра з 6 гравцями</td>
                        <td className={StaticPageStyles.priceCell}>11
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h4 style={{textAlign:"left", marginLeft: "24px", paddingLeft: "0.5em", marginBottom: "-12px", backgroundColor: "white", zIndex:50, width:"11em"}}> Ігри без відео звязку</h4>
                <table className={StaticPageStyles.priceTable}>
                    <thead>
                    <th>Тип гри</th>
                    <th>Ціна</th>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Проведення індивідуальної гри</td>
                        <td className={StaticPageStyles.priceCell}>1
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Проведення групової гри</b></td>
                    </tr>
                    <tr>
                        <td> - гра з 2 гравцями</td>
                        <td className={StaticPageStyles.priceCell}>2
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - кожен додатковий гравець</td>
                        <td className={StaticPageStyles.priceCell}>0.5
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <small style={{display: "flex", flexDirection: "row", justifyContent: "center"}}> ** <div
                    className={StaticPageStyles.coinSmall}/> є приблизним еквівалентом 1 EUR на момент поповнення
                    рахунку</small>
                <br/>
            </div>

        </div>
    </div>
}